import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Apartamentos', path: '/apartamentos' },
    { name: 'Experiências', path: '/experiencias' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contactos', path: '/contactos' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/46d54fb9-4fce-4c4d-b3cf-25c9c85dceea.png" 
              alt="Seaview & Levada Escape Logo" 
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled
                    ? 'text-gray-700 hover:text-sea-blue'
                    : location.pathname === '/'
                    ? 'text-white hover:text-sand-beige'
                    : 'text-gray-700 hover:text-sea-blue'
                } ${location.pathname === link.path ? 'text-sea-blue' : ''}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <Link
            to="/apartamentos"
            className={`hidden md:block px-6 py-2.5 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'bg-sea-blue text-white hover:bg-sea-blue/90 hover:shadow-lg'
                : 'bg-white text-sea-blue hover:bg-sand-beige'
            }`}
          >
            Reservar Agora
          </Link>

          <button className="md:hidden text-2xl cursor-pointer">
            <i className={`ri-menu-line ${isScrolled || location.pathname !== '/' ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;